import httpManager from "@/app/shared/utils/httpManager";
import { TABLE_PAGE_SIZE_REDUCE } from "@/app/shared/utils/constants";
import { Pagination } from "@/@types/global";

export interface FilterReferral {
  search?: string;
  state?: string | number;
}
class ReferralService {
  baseUrl = "/referrals/";

  async getReferralContent({
    search = '',
    state = ''
  }: FilterReferral, pagination: Pagination): Promise<any> {
    const offset = (pagination.current - 1 || 0) * TABLE_PAGE_SIZE_REDUCE;
    const pageSize = pagination.pageSize || TABLE_PAGE_SIZE_REDUCE;
    if(state == 0) state=''

    const url = `${this.baseUrl}?search=${search}&state=${state}&offset=${offset}&limit=${pageSize}`;
    console.log(url, 'url referral content');
    const response = await httpManager.get(url);
    const data = response.data;
    const totals = data?.totals ?? {};
    // const data = {results:[],count:0};
    const normalize = v => (typeof v === 'number' && Number.isFinite(v) ? v : 0);
    return {
      total_earned: normalize(totals.total_earned ?? 0),
      total_referrals: normalize(totals.total_referrals ?? 0),
      items: data.results || [],
      pagination: {
        total: data.count || 0,
        pageSize: TABLE_PAGE_SIZE_REDUCE,
      }
    };
  }

  async createReferral(user: any) {
    const response = await httpManager.post(this.baseUrl, user);
    return response;
  }
}

export const referralService = new ReferralService();
